import { z, type ZodEnum, type ZodSchema } from 'zod';

type Routes = [string, ...string[]];
type Route<T extends Routes> = T[number];
type SerializedNavigationSchema<T extends Routes> = {
  pathname: T[number];
  timestamp: Date;
};

type RoutesSchema<T extends Routes> = ZodSchema<SerializedNavigationSchema<T>>;

export function createSerializedNativationSchema<T extends Routes>(
  routesSchema: ZodEnum<T>
) {
  return z.object({
    pathname: routesSchema,
    timestamp: z.coerce.date(),
  }) as RoutesSchema<T>;
}

export function deserializeNavState<R extends Routes>(
  rawValue: unknown,
  schema: RoutesSchema<R>
) {
  const validate = schema.safeParse(rawValue);
  const { success } = validate;
  if (success === true) {
    return validate.data;
  }
}

export function getNavResumeRoute<T extends Routes>({
  defaultRoute,
  navigationState,
}: {
  navigationState: SerializedNavigationSchema<T>;
  defaultRoute: Route<T>;
}): Route<T> | undefined {
  const { timestamp: deserializedTimestamp, pathname } = navigationState;
  const timestamp = new Date(deserializedTimestamp);
  const now = new Date();
  const msDiff = Math.abs(timestamp.getTime() - now.getTime());
  const hrsDiff = msDiff / (60 * 60 * 1000);

  if (hrsDiff > 24) {
    return defaultRoute;
  }

  return pathname;
}
